import { type IncidentType } from "@/lib/types";

/** Enabled module names for a matter type (same labels as matter-type-table-columns). */
export function getIncidentTypeModuleLabels(
  incidentType: IncidentType,
): string[] {
  const labels: (string | null)[] = [
    incidentType.emailModuleAccess ? "Email" : null,
    incidentType.expenseModuleAccess ? "Expense" : null,
    incidentType.incidentModuleAccess ? "Incident" : null,
    incidentType.incidentReportModuleAccess ? "Incident Report" : null,
    incidentType.intakePropertyDamageModuleAccess
      ? "Intake Property Damage"
      : null,
    incidentType.intakeResponsesModuleAccess ? "Intake Responses" : null,
    incidentType.lienModuleAccess ? "Lien" : null,
    incidentType.litigationModuleAccess ? "Litigation" : null,
    incidentType.lostWagesModuleAccess ? "Lost Wages" : null,
    incidentType.medicalTreatmentModuleAccess ? "Medical Treatment" : null,
    incidentType.settlementModuleAccess ? "Settlement" : null,
    incidentType.trustCheckModuleAccess ? "Trust Check" : null,
    incidentType.injuriesModuleAccess ? "Injuries" : null,
    incidentType.insuranceModuleAccess ? "Insurance" : null,
    incidentType.signatureRequestModuleAccess ? "Signature Requests" : null,
    incidentType.vehicleModuleAccess ? "Vehicle" : null,
  ];
  return labels.filter((x): x is string => x !== null);
}
